var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFreeship = function SvgFreeship(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M6.667 22.667a2.667 2.667 0 0 0 5.333 0m-5.333 0a2.667 2.667 0 0 1 5.333 0m-5.333 0H4v-5.334m8 5.334h8m0 0a2.667 2.667 0 0 0 5.334 0m-5.334 0a2.667 2.667 0 0 1 5.334 0m0 0H28v-8m-25.333-8h14.667v16m10.666-8H17.334m10.666 0L24 8h-6.666M4 12h5.334"
  })));
};
export default SvgFreeship;